(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .controller('ContractController', ContractController);

    ContractController.$inject = ['$scope','ContractMinDTO','ContractGridDTO','AlertService','SingleDblClickService','category','$uibModal','CompanyCustomService',
    'PortCustomService','ContractCustomService','Principal'];

    function ContractController($scope, ContractMinDTO, ContractGridDTO, AlertService, SingleDblClickService, category, $uibModal, CompanyCustomService,
                                PortCustomService, ContractCustomService, Principal) {
        var vm = this;

        vm.category = category;
        vm.contracts = [];
        vm.loadPage = loadPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.initFilter = initFilter;

        vm.filterModel = {};
        $scope.dateOptions = {
            formatYear: 'yy',
            startingDay: 1
        };
        $scope.contractDateFrom = {
            opened: false
        };
        $scope.contractDateTo = {
            opened: false
        };
        $scope.openContractDateFrom = function () {
            $scope.contractDateFrom.opened = true;
        };
        $scope.openContractDateTo = function () {
            $scope.contractDateTo.opened = true;
        };
        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.contractDateFrom = false;
        vm.datePickerOpenStatus.contractDateTo = false;

        vm.fieldsMapping = {
        };

        vm.getContractFieldName = function(dtoName) {
            return vm.fieldsMapping[dtoName] || dtoName;
        };

        vm.gridOptions = {
            paginationPageSizes: [10, 25, 50, 75, 100],
            paginationPageSize: 100,
            enableFiltering: false,
            enableGridMenu: true,
            enableRowSelection: true,
            enableSelectAll: true,
            showGridFooter: true,
            useExternalPagination: true,
            rowTemplate: SingleDblClickService.rowTemplate(),
            onRegisterApi: function (gridApi) {
                gridApi.pagination.on.paginationChanged($scope, function (newPage, pageSize) {
                    vm.page = newPage - 1;
                    loadAll();
                });
                gridApi.core.on.sortChanged($scope, function (grid, sortColumns) {
                    if (sortColumns && sortColumns.length > 0 && sortColumns[0]) {
                        vm.predicate = vm.getContractFieldName(sortColumns[0].field);
                        vm.reverse = sortColumns[0].sort.direction === 'asc';
                    } else {
                        vm.predicate = 'id';
                        vm.reverse = true;
                    }
                    loadAll();
                });
                $scope.gridApi = gridApi;
            },
            enableColumnResizing: true,
            columnDefs: [
                {
                    name: 'Actions',
                    cellTemplate: '<div style="display:table-cell; text-align: center; vertical-align:middle;width: 100px;height: 30px;">' +
                    '<button class="btn btn-primary btn-xs" ng-click="grid.appScope.rowCopyClick(row.entity)" ng-dblclick="grid.appScope.rowCopyDbClick(row.entity)">Copy</button>' +
                    '</div>',
                    width: 100,
                    visible: true
                },
                {name: 'Contract #', field: 'contractNum', width: 200, visible: true},
                {name: 'Date', field: 'contractDate', width: 130, visible: true},
                {name: 'Type', field: 'contractType', width: 110, visible: true},
                {name: 'Status', field: 'status', width: 130, visible: true},
                {name: 'Category', field: 'category', width: 100, visible: true},
                {name: 'S.Category', field: 'subCategory', width: 120, visible: true},
                {name: 'CY', field: 'cropYear', width: 75, visible: true},
                {name: 'Qty', field: 'qtyDisplay', width: 150, visible: true},
                {name: 'Price Model', field: 'priceModel', width: 120, visible: true},
                {name: 'Price', field: 'priceDisplay', width: 120, visible: true},
                {name: 'Buyer', field: 'buyer', width: 200, visible: true},
                {name: 'O.Buyer', field: 'outsideBuyer', width: 200, visible: true},
                {name: 'Seller', field: 'seller', width: 200, visible: true},
                {name: 'L. Port', field: 'loadingPort', width: 150, visible: true},
                {name: 'D. Port', field: 'destinationPort', width: 150, visible: true},
                {name: 'Agent', field: 'thirdParty', width: 200, visible: true},
                {name: 'Growth', field: 'growth', width: 150, visible: true}
            ]
        };

        vm.sellers = [];
        vm.buyers = [];
        vm.thirdParties = [];
        vm.loadingPorts = [];
        vm.destinationPorts = [];
        vm.incoTerms = [];
        vm.paymentTerms = [];
        vm.grades = [];
        vm.growths = [];

        initFilter();
        loadAll();

        getPrincipal();
        vm.isAgent = false;
        function getPrincipal() {
            Principal.identity().then(function(account) {
                vm.principal = account;
                vm.isAgent = vm.principal.authorities.includes('ROLE_AGENT');
                if(vm.isAgent) {
                    vm.gridOptions.columnDefs[0].visible = false;
                    vm.gridOptions.columnDefs[4].visible = false;
                    vm.gridOptions.columnDefs[5].visible = false;
                    vm.gridOptions.columnDefs[6].visible = false;
                    vm.gridOptions.columnDefs[11].visible = false;
                    if(vm.category.type === 'SALE') {
                        vm.gridOptions.columnDefs[10].visible = false;
                    }
                }
            });
        }

        function initFilter() {
            vm.filterModel = {
                contractNum: '',
                contractType: vm.category.type,
                priceModel: '',
                seller: '',
                outsideBuyer: '',
                buyer: '',
                agent: '',
                loadingPort: '',
                destinationPort: '',
                incoTerms: '',
                paymentTerms: '',
                grade: '',
                contractDateFrom: null,
                contractDateTo: null,
                cropYear: '',
                growth: '',
                draft: true,
                issued: true,
                complete: true,
                cancelled: false,
                categoryTui: true,
                categoryJapan: true,
                subCategoryJapan: true,
                subCategoryOutside: true,
                subCategoryPurchase: true,
                subCategoryDirect: true
            };
        }

        function loadAll() {
            if (vm.gridOptions) {
                vm.gridOptions.data = [];
            }
            vm.contracts = [];
            var queryParams = {
                page: vm.page,
                size: vm.gridOptions.paginationPageSize,
                sort: sort()
            };
            if (vm.category.status && vm.category.status.length > 0) {
                queryParams.status = vm.category.status;
            }
            queryParams = Object.assign({}, queryParams, vm.filterModel);

            ContractGridDTO.query(queryParams, onSuccess, onError);

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                for (var i = 0; i < data.length; i++) {
                    vm.contracts.push(data[i]);
                }
                vm.gridOptions.data = vm.contracts;
                vm.gridOptions.totalItems = headers('X-Total-Count');
                if(vm.category.type === 'PURCHASE') {
                    vm.gridOptions.columnDefs[4].visible = true;
                    vm.gridOptions.columnDefs[11].visible = false;
                    vm.gridOptions.columnDefs[12].visible = false;
                } else if(vm.category.type === 'SALE') {
                    vm.gridOptions.columnDefs[13].visible = false;
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset() {
            vm.page = 0;
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear() {
            vm.contracts = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        $scope.rowSingleClick = function (row) {
            if (!$scope.copyButtonClicked) {
                if (vm.category.type === 'SALE') {
                    SingleDblClickService.singleClick(row, 'sale.sale-detail', 'contract');
                } else if (vm.category.type === 'PURCHASE') {
                    SingleDblClickService.singleClick(row, 'purchase.purchase-detail', 'contract');
                }
            }
            $scope.copyButtonClicked = false;
        };

        $scope.rowDblClick = function (row) {
            if(vm.isAgent) {
                if (vm.category.type === 'SALE') {
                    SingleDblClickService.dblClickAgent(row, 'sale.sale-detail', 'contract');
                } else if (vm.category.type === 'PURCHASE') {
                    SingleDblClickService.dblClickAgent(row, 'purchase.purchase-detail', 'contract');
                }
            } else {
                if (!$scope.copyButtonClicked) {
                    if (vm.category.type === 'SALE') {
                        SingleDblClickService.dblClick(row, 'sale.edit', 'contract');
                    } else if (vm.category.type === 'PURCHASE') {
                        SingleDblClickService.dblClick(row, 'purchase.edit', 'contract');
                    }
                }
                $scope.copyButtonClicked = false;
            }
        };

        $scope.rowCopyClick = function(row) {
            $scope.copyButtonClicked = true;

            $uibModal.open({
                templateUrl: 'app/entities/contract/dialog/contract-copy-dialog.html',
                controller: 'ContractCopyDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                resolve: {
                    entity: function () {
                        return row;
                    }
                }
            }).result.then(function () {
                $scope.copyButtonClicked = false;
                vm.loadAll();
            }, function () {
                $scope.copyButtonClicked = false;
                vm.loadAll();
            });
        };

        $scope.rowCopyDbClick = function(row) {
            $scope.rowCopyClick(row);
        };

        vm.createTab = function (data) {
            $scope.$emit('handleEmit', data);
        };

        vm.createContract = function() {
            var route = 'sale.new';
            var heading = 'New Sale Contract';
            if (vm.category.type === 'PURCHASE') {
                route = 'purchase.new';
                heading = 'New Purchase Contract';
            }
            var subCategory;
            if (vm.category.status && vm.category.status.length > 0) {
                subCategory = vm.category.status;
            }
            var data = {
                heading: heading,
                route: route,
                id: ''
            };
            if (subCategory) {
                data.param = {
                    subCategory: subCategory
                };
            }
            vm.createTab(data);
        };

        vm.cleanFilter = function() {
            initFilter();
            vm.reset();
        };
    }
})();
